var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThreeDotVerticalIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 13.5c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1m0-10c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1m0 5c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1"
})));
export { SvgThreeDotVerticalIcon as ReactComponent };
export default __webpack_public_path__ + "9e99e9452d363c57b43c85fa40e72c8f.svg";